<p>
  exit-dialog works!
</p>
